export default __webpack_public_path__ + "static/media/004-coat.a9084cac.svg";